// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"143":"f05562ab","152":"a830c717","217":"1ca2a12e","249":"c1c0b360","338":"d7dd3001","408":"b60d82b4","453":"db8d6002","524":"b2901632","555":"c82a8332","667":"bddda074","716":"8cf60941","732":"81fa4d28","771":"26195b1f","811":"a7db0946"}[chunkId] + ".chunk.js";
};